import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/atlassian': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M152.2 236.4c66.3 70.8 89.1 189.3 51.2 267.1-2.4 5.2-7.6 8.5-13.4 8.4h-175c-11 0-18.4-11.7-13.4-21.7l125.8-251c5.1-10.5 17.1-11 24.8-2.8zM244.4 8.1c6.8-10.9 20.3-10.7 25.6-0.1 5.9 11.7 240.4 482.3 240.4 482.3 5 9.9-2.2 21.7-13.4 21.7h-174.2c-5.7 0-10.9-3.3-13.4-8.4-73.5-146.9-187.3-302.1-65-495.5z'
      }
    ]
  }
})
